import { InstanceData, InstanceDataType, PreviewStageView, RenderStageView, StoreProvider } from '@/framework';
import { Framework } from '@/framework/instance';
import { chartHoverPlugin } from '@/plugins/chart-hover';
import { PreviewSvipWatermarkView } from '@/plugins/svip-watermark';
import { IExportPlugin, ILayerProps, PluginType } from '@/version-types';

export class Preview extends Framework {
    getPPTPreviewNode(layers: ILayerProps[]) {
        const state = InstanceData.getData(this.identity, InstanceDataType.State) as any;
        return (
            <StoreProvider state={state}>
                <PreviewStageView layers={layers} />
                {chartHoverPlugin.render!()}
            </StoreProvider>
        );
    }

    getWatermarkNode(stageIndex: number, fetchLayers?: (layerId: string[]) => ILayerProps[]) {
        const state = InstanceData.getData(this.identity, InstanceDataType.State) as any;

        return (
            <StoreProvider state={state}>
                <PreviewSvipWatermarkView stageIndex={stageIndex} fetchLayers={fetchLayers} />;
            </StoreProvider>
        );
    }

    getNavigatorNode(originIndex: number) {
        const state = InstanceData.getData(this.identity, InstanceDataType.State) as any;
        return (
            <StoreProvider state={state}>
                <RenderStageView
                    extraProps={{
                        identity: this.framework.identity,
                        isNavigator: true,
                    }}
                    originIndex={originIndex}
                    isLongImageMode={false}
                />
            </StoreProvider>
        );
    }
}

/**
 * 预览插件扩展
 */
export const previewExtension: IExportPlugin = {
    sort: 0,
    type: PluginType.EXTENSION,
    name: 'preview-extension',
    createInstance({ identity }) {
        return [{ key: 'Preview', value: new Preview(identity) }];
    },
};
